import { createAction, props } from '@ngrx/store';
import { User } from '../../models/user.model';


export const setUserDataAction = createAction('[AUTH] Set User Data', props<{ userData: User }>());
export const clearUserDataAction = createAction('[AUTH] Clear User Data');
